import { FunnelIcon } from "@phosphor-icons/react/Funnel";

import type { FilterShipmentsDescription } from "@/Shared/ShipmentFilter/Dialogs/Internal/FilterShipmentsDialogBody";
import type { SortShipmentOptions } from "@/Shared/Shipment/SortShipmentOptions";
import { ViewShipmentsFilterPills } from "../CustomComponents/ViewShipmentsFilterPills";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { ControlPresentationProvider } from "@freightsimple/ui-core/Controls/ControlPresentationProvider";
import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { T } from "@freightsimple/ui-core/Typography/T";
import {
  viewShipmentsSortGroups,
  viewShipmentsSortOptions,
} from "../Helpers/viewShipmentsSortOptions";

interface FilterBarProps {
  onFilter: () => Promise<void>;
  onSortChange: (sort: SortShipmentOptions) => void;
  filter: FilterShipmentsDescription;
  sort: SortShipmentOptions;
  setFilter: (newFilter: FilterShipmentsDescription) => void;
}

export function ViewShipmentsFilterBar(props: FilterBarProps) {
  return (
    <Row align="center" gap={4}>
      <Row gap={4} align="center">
        {/* A real button, not link text: it opens a dialog rather than
            navigating, and it sits next to the sort dropdown — as a run of
            blue text it read as a footnote beside the control it partners.
            Matches the Filters button on hubble's shipment search. */}
        <Button
          icon={FunnelIcon}
          iconWeight="fill"
          tooltip="Choose which shipments to show"
          onClick={props.onFilter}
        >
          Filter Shipments
        </Button>
        {/* Boxed, so the sort reads as the control it is — picking a sort was a
            whole dialog of link text, which is a lot of ceremony for choosing
            one of eight. The screen is underlined, so the provider opts this
            one control back into the dense look. */}
        {/* The label sits beside the control, not above it via FormItem: this
            is a filter bar, not a form, and a stacked label left the dropdown
            taller than the button next to it and the pair looking lopsided. */}
        <ControlPresentationProvider presentation="boxed">
          <Row gap={2} align="center">
            <T size="sm" nowrap>
              Sort by
            </T>
            <Dropdown
              options={viewShipmentsSortOptions}
              groups={viewShipmentsSortGroups}
              value={props.sort}
              onChange={(value) =>
                props.onSortChange(value as SortShipmentOptions)
              }
              width="md"
              data-testid="sort-shipments-dropdown"
            />
          </Row>
        </ControlPresentationProvider>
      </Row>

      <ViewShipmentsFilterPills
        filter={props.filter}
        setFilter={props.setFilter}
      />
    </Row>
  );
}
